const state = {
  menuIsVisible: false,
  portfoliosData: [],
  advisorsData: [],
  currentPortfolioAnalysis: {}
};
const getters = {
  menuIsVisible: state => state.menuIsVisible,
  portfoliosData: state => state.portfoliosData,
  advisorsData: state => state.advisorsData,
  currentPortfolioAnalysis: state => state.currentPortfolioAnalysis,
  fondosrv: state => state.currentPortfolioAnalysis.fondosRV,
  fondosrf: state => state.currentPortfolioAnalysis.fondosRF,
  capitales: state => state.currentPortfolioAnalysis.capitales,
  deuda: state => state.currentPortfolioAnalysis.deuda,
  estructurados: state => state.currentPortfolioAnalysis.estructurados,
  labels: state => state.currentPortfolioAnalysis.labels
};
const actions = {
  toggleMenu (context, data) {
    context.commit('updateIsMenuVisible', data)
  },
  savePortfolios (context, data) {
    context.commit('updatePortfoliosData', data)
  },
  saveAdvisors (context, data) {
    context.commit('updateAdvisorsData', data)
  },
  saveCurrentPortfolioAnalysis(context, data) {
    context.commit('updatePortfolioAnalysis', data)
  }
}
const mutations = {
  updateIsMenuVisible(state, data) {
    state.menuIsVisible = data;
  },
  updatePortfoliosData(state, data) {
    state.portfoliosData = data
  },
  updateAdvisorsData(state, data) {
    state.advisorsData = data
  },
  updatePortfolioAnalysis(state, data) {
    state.currentPortfolioAnalysis = {}
    state.currentPortfolioAnalysis = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/app-info.js